/** @format */

import React from 'react';
import { observer, inject } from 'mobx-react';
import { Table, Form, Icon } from 'semantic-ui-react';
import AdminPage from '../shared/AdminPage/AdminPage';
import AdminPageModal from '../shared/AdminPage/AdminPageModal/AdminPageModal';

@inject('WarehousesStore')
@observer
class AdminWarehouses extends AdminPage {
  getStore = () => {
    const { WarehousesStore } = this.props;
    return WarehousesStore;
  };

  renderTableModal = () => {
    const { WarehousesStore } = this.props;
    const options = WarehousesStore.getItems.map(wh => ({
      key: wh.uid,
      text: wh.name,
      value: wh.uid,
    }));
    const priorities = WarehousesStore.edit.priorityWarehouses.map(
      priority => ({
        key: priority.uid,
        text: priority.name,
        value: priority.uid,
      }),
    );

    return (
      <AdminPageModal
        open={WarehousesStore.edit.modal}
        errors={WarehousesStore.edit.errors}
        toggleEditModal={WarehousesStore.toggleEditModal}
        currentItem={WarehousesStore.edit.currentItem}
        onSubmit={WarehousesStore.submit}
        onDelete={WarehousesStore.deleteItem}
        isEdit={WarehousesStore.edit.currentItem.uid}
      >
        <Form.Group widths="equal">
          <Form.Input
            name="name"
            value={WarehousesStore.edit.currentItem.name}
            onChange={(e, input) =>
              WarehousesStore.handleInputChange(input.value, 'name')
            }
          />
        </Form.Group>
        {priorities.map((warehouse, index) => {
          return (
            <Form.Group key={index}>
              <Form.Select
                search
                onChange={(e, input) =>
                  WarehousesStore.handlePriorityChange(input.value, index)
                }
                options={options}
                name={`priority[${index}]`}
                label={`Priorità ${index + 1}`}
                placeholder="Magazzino"
                defaultValue={warehouse.value}
              />
              <Form.Button
                type="button"
                icon={<Icon name="times" />}
                label="Rimuovi"
                onClick={e => WarehousesStore.removePriority(index)}
                style={{ color: 'red', backgroundColor: 'transparent' }}
              />
            </Form.Group>
          );
        })}
        <Form.Group>
          <Form.Button type="button" onClick={WarehousesStore.addPriority}>
            Aggiungi priorità
          </Form.Button>
        </Form.Group>
      </AdminPageModal>
    );
  };

  renderPlainPriority = priority => {
    const { WarehousesStore } = this.props;
    let priorityArr = [];
    for (let index in priority) {
      priorityArr.push([index, priority[index]]);
    }
    priorityArr = priorityArr.sort((a, b) => a[1] - b[1]);
    return priorityArr
      .map(warehouse => {
        return WarehousesStore.items[warehouse[0]].name;
      })
      .join(' > ');
  };

  renderTableBody = () => {
    const { WarehousesStore } = this.props;
    const warehouses = WarehousesStore.searchedItems;

    return warehouses.map(warehouse => {
      return (
        <Table.Row
          key={warehouse.uid}
          onClick={() => {
            WarehousesStore.toggleEditModal();
            WarehousesStore.loadCurrentItem(warehouse.uid);
          }}
        >
          <Table.Cell>{warehouse.name}</Table.Cell>
          <Table.Cell>
            {this.renderPlainPriority(warehouse.priority)}
          </Table.Cell>
        </Table.Row>
      );
    });
  };
}

export default AdminWarehouses;
